const MAPPING_TYPES = {
  DATA: 'DATA',
  SCORE: 'SCORE'
};

module.exports = {
  MAPPING_TYPES
};
